var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToiletPaperBlankUnder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 384C469 384 512 298 512 192C512 86 469 0 416 0S320 86 320 192C320 298 363 384 416 384ZM416 128C433.625 128 448 156.625 448 192S433.625 256 416 256S384 227.375 384 192S398.375 128 416 128ZM288 192C288 108.402 311.674 38.477 348.436 0H96C43 0 0 86 0 192C0 298 43 384 96 384H348.436C311.674 345.523 288 275.598 288 192ZM422.984 415.703L423.268 416H128V480C128 497.672 142.326 512 160 512H480C497.674 512 512 497.672 512 480V342.988C490.297 385.523 459.109 412.617 422.984 415.703Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletPaperBlankUnder);
export default __webpack_public_path__ + "static/media/toilet-paper-blank-under.b07efad40df841158ff10c787a6b3224.svg";
export { ForwardRef as ReactComponent };